import { useState } from 'react';
import { Button, Heading, Spinner, Tag, Text } from '@flixbus/honeycomb-react';
import { Icon, IconEye, IconEyeNo, IconProfile } from '@flixbus/honeycomb-icons-react';

import { useVoucher } from '../../context/VoucherProdiver';
import { DiscountTypeMap } from '../../types/Voucher';
import { unmaskVoucherCode } from '../../apis';
import { useNotification } from '../Notifications/Context';

import styles from './voucher-banner.module.scss';

const VoucherBanner = () => {
  const { data } = useVoucher();
  const { pushToast } = useNotification();

  const [unmaskedCode, setUnmaskedCode] = useState<string | null>(null);
  const [isRevealing, setIsRevealing] = useState(false);

  const isRevealed = unmaskedCode !== null;

  const handleReveal = async () => {
    setIsRevealing(true);
    try {
      const result = await unmaskVoucherCode(data.id);
      setUnmaskedCode(result.voucherCode);
    } catch {
      pushToast({ message: 'Failed to reveal voucher code', status: 'danger' });
    } finally {
      setIsRevealing(false);
    }
  };

  const handleHide = () => {
    setUnmaskedCode(null);
  };

  return (
    <div className={styles.container}>
      <div className={styles.voucherType}>
        <div className={styles.icon}>
          <flix-illustration name='voucher'></flix-illustration>
        </div>
        <div className={styles.voucherTypeText}>
          <Heading flushSpace size={4}>
            {DiscountTypeMap[data.discountType.type]}
          </Heading>
          <div className={styles.codeRow}>
            <Heading flushSpace size={1}>
              {isRevealed ? unmaskedCode : data.code}
            </Heading>
            {isRevealing ? (
              <Spinner size={'sm'} />
            ) : (
              <Button
                appearance='link'
                onClick={isRevealed ? handleHide : handleReveal}
                aria-label={isRevealed ? 'Hide voucher code' : 'Reveal voucher code'}
              >
                <Icon InlineIcon={isRevealed ? IconEye : IconEyeNo} />
              </Button>
            )}
          </div>
          <Text Elem='strong' small>
            Voucher ID: {data.id}
          </Text>
        </div>
      </div>
      <div className={styles.author}>
        <div className={styles.authorIcon}>
          <Icon InlineIcon={IconProfile} size={6}></Icon>
        </div>
        <div className={styles.authorText}>
          <Text extraClasses={styles.createdBy} small>
            Created by
          </Text>
          <Tag display='subtle' small>
            {data.createdBy || 'John Doe'}
          </Tag>
        </div>
      </div>
    </div>
  );
};

export default VoucherBanner;
